import { Component, ViewChild } from '@angular/core';
import { SinapiItemDto } from 'src/app/aplication/api/Manipulate/Sinapi';
import { CsvReaderService } from 'src/app/aplication/service/csvReader.service';

@Component({
  selector: 'app-sinapi',
  templateUrl: './sinapi.component.html',
  styleUrl: './sinapi.component.scss'
})
export class SinapiComponent {

  public listItems:SinapiItemDto[] = [];

  @ViewChild('fileUploaderDrop') fileUploaderDrop!: any;

  constructor(protected _readerCSV:CsvReaderService){}

  importFile(event: any) {
    const file: File = event.files[0];
    if (!file) {
      return;
    }
    this._readerCSV.convertSinapiExcelToJson(file).then((response) => {
      this.listItems = response.items; 
      console.log("Itens importados:", this.listItems);
    }).catch((err) => {
      console.error(err);
      if (this.fileUploaderDrop) {
        this.fileUploaderDrop.clear();
      }
    });
  }


}
